const ApiKey1 = "6221c3bb0fd72752d021ca10f5738bba";

export const ApiKey = ApiKey1;
